import React from "react";
import { Container } from "../../../components";
import FocusBox from "../../../components/components/molecules/FocusBox";
import { Heading, Link, Text } from "@telia/teddy";
import { connect } from "react-redux";
import { RootState } from "../../../../../models";
import "./ErrorPage.less";
import { getErrorMessage } from "../../../app/state/selectors";

interface ErrorPageProps {
    errorMessage: string;
}

const ErrorPage: React.FC<ErrorPageProps> = ({ errorMessage }) => {
    return (
        <div className="error-page">
            <Container size="medium" extraPaddingTop>
                <FocusBox>
                    <Heading mb="100" as="h2" variant="title-200">
                        Beklager, en feil har oppstått!
                    </Heading>
                    {errorMessage && <Text mb="100">{errorMessage}</Text>}
                    <Text mb="100">
                        Prøv en gang til ved å starte på{" "}
                        <Link variant="text" href="/">
                            forsiden
                        </Link>
                        .
                    </Text>
                </FocusBox>
            </Container>
        </div>
    );
};

const mapStateToProps = (state: RootState) => ({
    errorMessage: getErrorMessage(state),
});

export default connect(mapStateToProps)(ErrorPage);
